import React from "react";

export default function Checked({
  width = "42",
  height = "31",
  stroke = "#606f7b",
  strokeWidth = "1"
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 31"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Canvas" fill="none">
        <path
          id="Vector"
          d="M 0 16.3062L 11.822 28.4116L 40 1.18528e-07"
          transform="translate(1 1)"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/Checked.js